import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

//import "./plugins/axios";
import './firebase/firebaseConfig';
import './plugins/smoothScroll';

import './assets/lib/bootstrap/css/bootstrap.min.css';
import './assets/css/normalize.css';
import './assets/css/theme.css';
import './assets/css/theme/themelibrary.css';

import './assets/lib/fontawesome/index';

import i18n from './i18n/i18n'

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');